// Gestione avanzata del focus
document.addEventListener("focusin", (e) => {
  const searchActive = document.querySelector(
    ".header-search-wrapper--clone.active"
  );
  if (searchActive && !searchActive.contains(e.target)) {
    e.preventDefault();
    searchActive.querySelector("input").focus();
  }
});

// Ottimizzazione resize
let resizeTimeout;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    document
      .querySelectorAll(".header-search-wrapper--clone")
      .forEach((clone) => {
        const context = clone.classList.contains("context-sticky")
          ? "sticky"
          : "main";
        const manager = SearchManager.instances.get(context);
        manager?.positionClone();
      });
  }, 100);
});

/*******************************
 * Codice principale header_js
 *******************************/
if (typeof MainHeader !== "function") {
  class MainHeader extends HTMLElement {
    constructor() {
      super();
      this.mount();
    }

    mount() {
      /*******************
       * Gestione inert
       *******************/
      document.querySelectorAll("#main > div").forEach((elm) => {
        if (!elm.classList.contains("no-inert")) {
          elm.setAttribute("data-js-inert", "");
        }
      });
      window.inertElems = document.querySelectorAll("[data-js-inert]");

      /*******************
       * Sticky header
       *******************/
      if (this.hasAttribute("data-sticky-header")) {
        const stickyHeader = document.createElement("div");
        stickyHeader.classList = "sticky-header site-header";

        if (this.classList.contains("site-header--style-one-row")) {
          stickyHeader.innerHTML = `<div class="container--large">
    <div class="${this.querySelector(".header__top").className
            }" style="height:calc(var(--header-logo) + var(--header-vertical-space))">
      ${this.querySelector(".header__top").innerHTML}
    </div>
  </div>`;

          stickyHeader.className = `sticky-header ${this.className}`;
          stickyHeader.classList.remove("site-header--absolute");
        } else {
          // CASO "two-rows" (o comunque non "one-row") - QUI VA FATTA LA MODIFICA
          const headerTop = this.querySelector(".header__top");
          let gridClass = "header__top";
          if (headerTop && headerTop.classList.contains("header__top--logo-center")) {
            gridClass += " header__top--logo-center";
          }

          const areaLogoHTML = this.querySelector(".area--logo")?.outerHTML || "";
          const mobileMenuButtonHTML = this.querySelector(".mobile-menu-button")?.outerHTML || ""; // Prelevo l'HTML del bottone hamburger
          const areaCustomIconHTML = this.querySelector(".area--custom-icon")?.outerHTML || "";
          const searchFakeTriggerInnerHTML = this.querySelector(".area--search .search-fake-trigger")?.innerHTML || "";
          const areaAccountHTML = this.querySelector(".area--account")?.outerHTML || "";
          const areaWishlistHTML = this.querySelector(".frcp-wishlist-nav-link-wrapper")?.outerHTML || "";
          const areaCartHTML = this.querySelector(".area--cart")?.outerHTML || "";

          stickyHeader.innerHTML = `
            <div class="container--large">
              <div class="${gridClass}">
                <div class="sticky-icons1-wrapper">
                  ${mobileMenuButtonHTML} <!-- Bottone hamburger inserito qui -->
                  ${areaLogoHTML}
                </div>
                <div class="area--search">
                  <div class="search-fake-trigger header-search-form__inner" aria-expanded="false">
                    ${searchFakeTriggerInnerHTML}
                  </div>
                </div>
                <div class="sticky-icons-wrapper dx-align">
                  ${areaCustomIconHTML}
                  ${areaAccountHTML}
                  ${areaWishlistHTML}
                  ${areaCartHTML}
                </div>
              </div>
            </div>
            <div class="header__bottom header-container container--large portable-hide">
              ${this.querySelector(".header__bottom")?.innerHTML || ""}
            </div>`;
        }

        // Fix ID duplicati
        stickyHeader.querySelectorAll("[id]").forEach((elm) => {
          elm.id = `${elm.id}-sticky`;
        });

        document.body.append(stickyHeader);

        // Inizializza lo SearchManager per contesto "sticky"
        setTimeout(() => {
          if (!SearchManager.instances.has("sticky")) {
            const manager = new SearchManager("sticky");
          }

          // Forza un resize
          window.dispatchEvent(new Event("resize"));
        }, 300); // Aumentiamo il timeout per garantire che il DOM sia pronto

        // Rimuove ID duplicati su nav
        stickyHeader.querySelectorAll("[id]").forEach((elm) => {
          elm.id = `${elm.id}-sticky`;
        });
        stickyHeader
          .querySelectorAll(".site-nav [aria-controls]")
          .forEach((elm) => {
            elm.setAttribute(
              "aria-controls",
              `${elm.getAttribute("aria-controls")}-sticky`
            );
          });

        // Sticky scroll logic
        window.lst = window.scrollY;
        this.SCROLL_StickyHelper = () => {
          const st = window.scrollY;
          const mainHeaderRect = this.getBoundingClientRect();
          const stickyHideEarlyThreshold = 50; // Soglia per nascondere lo sticky in anticipo

          // Condizione PRIORITARIA per NASCONDERE lo sticky header:
          // 1. Se il main header è già visibile (anche parzialmente dal basso, mainHeaderRect.bottom > 0)
          // 2. O se il main header non è ancora visibile ma sta per diventarlo dall'alto (entro la soglia, mainHeaderRect.top > -stickyHideEarlyThreshold)
          if (mainHeaderRect.bottom > 0 || mainHeaderRect.top > -stickyHideEarlyThreshold) {
            if (stickyHeader.classList.contains("show")) {
              stickyHeader.classList.remove("show");
            }
          }
          // ALTRIMENTI (main header è ben nascosto SOPRA e non sta per entrare):
          // Si può considerare di MOSTRARE o NASCONDERE lo sticky header in base allo scroll.
          else {
            // Scroll VERSO L'ALTO: mostra lo sticky (Vecchia Logica B1 adattata)
            if (st < window.lst) {
              if (!stickyHeader.classList.contains("show")) {
                stickyHeader.classList.add("show");
                window.dispatchEvent(new Event("resize")); // Evento resize per coerenza
              }
            }
            // Scroll VERSO IL BASSO SIGNIFICATIVO e NON IN FONDO PAGINA: nascondi lo sticky (Vecchia Logica B2)
            else if (st > window.lst + 50 && st < document.body.scrollHeight - window.innerHeight - 100) {
              if (stickyHeader.classList.contains("show")) {
                stickyHeader.classList.remove("show");
              }
            }
            // Scroll VERSO L'ALTO e SI È IN FONDO PAGINA: mostra lo sticky (Vecchia Logica B3)
            else if (st >= document.body.scrollHeight - window.innerHeight - 100 && st < window.lst) {
              if (!stickyHeader.classList.contains("show")) {
                stickyHeader.classList.add("show");
                window.dispatchEvent(new Event("resize"));
              }
            }
            // Scroll VERSO IL BASSO (generico, non coperto da B2): nascondi lo sticky se mostrato.
            // Questa è una condizione aggiuntiva per maggiore reattività nel nascondere.
            else if (st > window.lst) {
              if (stickyHeader.classList.contains("show")) {
                stickyHeader.classList.remove("show");
              }
            }
            // Se st === window.lst (nessuno scroll verticale significativo), lo stato dello sticky non cambia.
          }
          window.lst = st;
        };

        window.addEventListener("scroll", this.SCROLL_StickyHelper, {
          passive: true,
        });
      }

      /********************
       * drawer connections
       ********************/
      document.querySelectorAll("[data-js-sidebar-handle]").forEach((elm) => {
        if (elm.hasAttribute("aria-controls")) {
          const elmSidebar = document.getElementById(
            elm.getAttribute("aria-controls")
          );
          elm.addEventListener("click", (e) => {
            e.preventDefault();
            elm.setAttribute("aria-expanded", "true");
            elmSidebar.show();
          });
          elm.addEventListener("keyup", (e) => {
            if (e.keyCode == window.KEYCODES.RETURN) {
              elm.setAttribute("aria-expanded", "true");
              elmSidebar.show();
              elmSidebar.querySelector("[data-js-close]").focus();
            }
          });
        }
      });

      // Posizionamento sidebar (alignment)
      if (
        this.classList.contains("site-header--alignment-left") ||
        this.classList.contains("site-header--style-one-row")
      ) {
        document
          .getElementById("site-search-sidebar")
          .classList.remove("sidebar--left");
        document
          .getElementById("site-search-sidebar")
          .classList.add("sidebar--right");
      }
      if (
        this.classList.contains("site-header--style-one-row") &&
        this.classList.contains("site-header--alignment-center")
      ) {
        document
          .getElementById("site-menu-sidebar")
          .classList.remove("sidebar--right");
        document
          .getElementById("site-menu-sidebar")
          .classList.add("sidebar--left");
      }

      // Chiusura drawer
      document
        .querySelectorAll("sidebar-drawer [data-js-close]")
        .forEach((elm) => {
          elm.addEventListener("click", (e) => {
            e.preventDefault();
            if (
              e.target.closest(".sidebar").classList.contains("sidebar--opened")
            ) {
              e.target.closest(".sidebar").hide();
            }
          });
        });

      // Clic overlay / ESC
      document.querySelector(".site-overlay").addEventListener("click", () => {
        if (document.querySelector(".sidebar--opened")) {
          document.querySelector(".sidebar--opened").hide();
        }
      });
      document.addEventListener("keydown", (e) => {
        if (e.keyCode == window.KEYCODES.ESC) {
          if (document.querySelector(".sidebar--opened")) {
            document.querySelector(".sidebar--opened").hide();
          }
        }
      });

      /*****************
       * resizing drawers
       *****************/
      const rootHeight = document.getElementById("root-height");
      this.RESIZE_SidebarHelper = debounce(() => {
        rootHeight.innerHTML = `:root {
          --window-height: ${window.innerHeight}px;
          --window-width: ${document.body.clientWidth}px;
        }`;
      }, 200);
      window.addEventListener("resize", this.RESIZE_SidebarHelper);
      rootHeight.innerHTML = `:root {
        --window-height: ${window.innerHeight}px;
        --window-width: ${document.body.clientWidth}px;
      }`;
      document.body.classList.add("header-loaded");

      /***************************
       * switch menu: _checkMenuWidth
       ***************************/
      this._previousWidth = window.innerWidth;
      this._checkMenuWidth();
      this._checkMenuWidth(); // (chiamato due volte di fila?)

      window.addEventListener(
        "resize",
        debounce(() => {
          const currentWidth = window.innerWidth;
          if (currentWidth < this._previousWidth) {
            this._checkMenuWidth();
          }
          this._previousWidth = currentWidth;
        }, 200)
      );

      /******************************
       * submenu masonry (Macy.js)
       ******************************/
      document
        .querySelectorAll(".site-nav.style--classic .submenu-masonry")
        .forEach((elm) => {
          if (typeof Macy !== "undefined" && Macy) {
            const submenuMacy = new Macy({
              container: elm,
              columns: parseInt(elm.getAttribute("data-columns")),
              margin: 30,
            });
            setTimeout(() => {
              submenuMacy.reInit();
            }, 100);
          }
        });

      /******************************
       * Predictive Search (lazy load)
       ******************************/
      function ensurePredictiveSearchLoaded() {
        if (!document.body.classList.contains("predictive-script-loaded")) {
          document.body.classList.add("predictive-script-loaded");

          const predictiveSearchJS = document.createElement("script");
          predictiveSearchJS.src = KROWN.settings.predictive_search_script;
          document.head.appendChild(predictiveSearchJS);
        }
      }

      const shopifyFeatures = document.getElementById("shopify-features");
      const hasPredictiveSearch =
        shopifyFeatures &&
        JSON.parse(shopifyFeatures.text)?.predictiveSearch === true;

      if (hasPredictiveSearch) {
        document
          .querySelectorAll("[data-js-open-search-drawer]")
          .forEach((elm) => {
            elm.addEventListener("click", (e) => {
              e.preventDefault();
              ensurePredictiveSearchLoaded();

              setTimeout(() => {
                document.querySelector("#search-form-sidebar")?.focus();
              }, 10);
            });
          });
      } else {
        // fallback => /search
        const sf = this.querySelector("search-form");
        if (sf) {
          sf.addEventListener("click", (e) => {
            e.preventDefault();
            window.location.href = KROWN.settings.routes.search_url;
          });
        }
      }

      /******************************
       * Touch menu helpers
       ******************************/
      const closeTouchSubmenus = (focusedElm, focusedParent = null) => {
        document.querySelectorAll(".style--classic li.focus").forEach((elm) => {
          if (!(elm === focusedElm || elm === focusedParent)) {
            elm.classList.remove("focus");
          }
        });
      };
      let babyMenuTouch = false;
      if (
        "ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch)
      ) {
        document
          .querySelectorAll(".style--classic .has-babymenu > a")
          .forEach((elmLink) => {
            const elm = elmLink.parentElement;
            elmLink.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              elm.classList.toggle("focus");
              babyMenuTouch = true;
              closeTouchSubmenus(elm, elm.closest(".has-submenu"));
            });
          });
        document
          .querySelectorAll(".style--classic .has-submenu > a")
          .forEach((elmLink) => {
            const elm = elmLink.parentElement;
            if (!elm.classList.contains("mega-link")) {
              elmLink.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (!babyMenuTouch) {
                  elm.classList.toggle("focus");
                  closeTouchSubmenus(elm);
                }
                babyMenuTouch = false;
              });
            }
          });
      }

      /******************************
       * tab navigation for the menu
       ******************************/
      document
        .querySelectorAll(".site-nav.style--classic .has-submenu > a")
        .forEach((childEl) => {
          const elm = childEl.parentNode;
          elm.addEventListener("keydown", (e) => {
            if (e.keyCode == window.KEYCODES.RETURN) {
              if (!e.target.classList.contains("no-focus-link")) {
                e.preventDefault();
              }
              if (!elm.classList.contains("focus")) {
                elm.classList.add("focus");
                elm.setAttribute("aria-expanded", "true");
              } else if (
                document.activeElement.parentNode.classList.contains(
                  "has-submenu"
                ) &&
                elm.classList.contains("focus")
              ) {
                elm.classList.remove("focus");
                elm.setAttribute("aria-expanded", "true");
              }
            }
          });

          const lastItem = elm.querySelector(
            ".submenu-holder > li:last-child a"
          );
          if (lastItem) {
            lastItem.addEventListener("focusout", (e) => {
              if (elm.classList.contains("focus")) {
                elm.classList.remove("focus");
                elm.setAttribute("aria-expanded", "false");
              }
            });
          }
        });

      document
        .querySelectorAll(
          ".site-nav.style--classic .has-babymenu:not(.mega-link) > a"
        )
        .forEach((childEl) => {
          const elm = childEl.parentNode;
          elm.addEventListener("keydown", (e) => {
            if (e.keyCode == window.KEYCODES.RETURN) {
              if (!e.target.classList.contains("no-focus-link")) {
                e.preventDefault();
              }
              if (!elm.classList.contains("focus")) {
                elm.classList.add("focus");
                elm.setAttribute("aria-expanded", "true");
              } else {
                elm.classList.remove("focus");
                elm.setAttribute("aria-expanded", "false");
              }
            }
          });

          const babyLast = elm.querySelector(".babymenu li:last-child a");
          if (babyLast) {
            babyLast.addEventListener("focusout", (e) => {
              if (elm.parentNode.classList.contains("focus")) {
                elm.parentNode.classList.remove("focus");
                elm.parentNode.setAttribute("aria-expanded", "false");
              }
            });
          }
        });
    } // Fine mount()

    unmount() {
      window.removeEventListener("resize", this.RESIZE_SidebarHelper);
      window.removeEventListener("scroll", this.SCROLL_StickyHelper);
      document.querySelector(".sticky-header")?.remove();
    }

    _checkMenuWidth() {
      const header = document.querySelector(".site-header--menu-classic");
      if (!header) return;

      const classicMenu = header.querySelector(".area--menu-classic");
      if (!classicMenu) return;

      const logo = header.querySelector(".area--logo");
      const logoIsCentered = header.classList.contains(
        "header__top--logo-center"
      );

      const headerStyle = window.getComputedStyle(header);
      const headerPaddingRight = parseFloat(
        headerStyle.getPropertyValue("padding-right")
      );
      const headerPaddingLeft = parseFloat(
        headerStyle.getPropertyValue("padding-left")
      );
      const headerRowGap = 10;

      const headerWidth =
        header.offsetWidth - headerPaddingLeft - headerPaddingRight;
      const logoWidth = logo.offsetWidth;
      const classicMenuWidth = classicMenu.offsetWidth + headerRowGap;

      const headerItems = header.children;
      let totalWidthOfHeaderItems = 0;
      for (let i = 0; i < headerItems.length; i++) {
        if (headerItems[i].offsetWidth > 0) {
          totalWidthOfHeaderItems += headerItems[i].offsetWidth + headerRowGap;
        }
      }
      totalWidthOfHeaderItems -= headerRowGap; // riduce l'ultimo gap

      let availWidthforClassicMenu = 0;
      if (logoIsCentered) {
        availWidthforClassicMenu =
          headerWidth / 2 - logoWidth / 2 - headerRowGap;
      } else {
        let otherElementsWidth =
          totalWidthOfHeaderItems - logoWidth - classicMenuWidth;
        availWidthforClassicMenu = headerWidth - otherElementsWidth - logoWidth;
      }

      if (classicMenuWidth > availWidthforClassicMenu) {
        header.classList.remove("site-header--menu-classic");
        header.classList.add("site-header--menu-minimal");
        classicMenu.remove();
      }
    }

    _adjustNavLayout() {
      if (
        this.querySelector(".site-nav") &&
        this.querySelector(".site-nav").classList.contains("style--classic")
      ) {
        if (
          this.querySelector("nav > ul").scrollWidth >
          this.querySelector("nav").offsetWidth
        ) {
          this.classList.add("site-header--swap-menu-style");
          document.body.classList.remove("header--has-two-rows");
          let header = document.getElementById("site-header");
          let twoRowsDetected = header.querySelectorAll('[class*="two-rows"]');
          twoRowsDetected.forEach((el) => {
            el.className = el.className.replace("two-rows", "one-row");
          });
        }
      }
    }
  }

  // Registra <main-header> se non già definito
  if (!customElements.get("main-header")) {
    customElements.define("main-header", MainHeader);
  }
}

/************************************************************
 * Code for SidebarDrawer, MobileNavigation, etc (unchanged)
 ************************************************************/
if (typeof SidebarDrawer !== "function") {
  class SidebarDrawer extends HTMLElement {
    constructor() {
      super();

      this.querySelector("[data-js-close]")?.addEventListener("click", () => {
        this.hide();
      });
      document.addEventListener("keydown", (e) => {
        if (e.keyCode == window.KEYCODES.ESC) {
          const openedSidebar = document.querySelector(
            "sidebar-drawer.sidebar--opened"
          );
          if (openedSidebar) {
            openedSidebar.hide();
          }
        }
      });
    }

    show() {
      this._opened = true;
      document.body.classList.add("sidebar-opened");

      if (this.classList.contains("sidebar--right")) {
        document.body.classList.add("sidebar-opened--right");
      } else if (this.classList.contains("sidebar--left")) {
        document.body.classList.add("sidebar-opened--left");
      }

      if (
        this.id == "site-cart-sidebar" &&
        document.getElementById("cart-recommendations-sidebar")
      ) {
        setTimeout(() => {
          document
            .querySelector("#cart-recommendations-sidebar css-slider")
            ?.resetSlider();
        }, 10);
      }

      this.style.display = "grid";
      setTimeout(() => {
        this.classList.add("sidebar--opened");
        if (window.inertElems) {
          window.inertElems.forEach((elm) => {
            elm.setAttribute("inert", "");
          });
        }
      }, 15);
    }

    hide() {
      this._opened = false;
      this.classList.remove("sidebar--opened");
      document.body.classList.remove("sidebar-opened");
      document.body.classList.remove("sidebar-opened--left");
      document.body.classList.remove("sidebar-opened--right");

      if (window.inertElems) {
        window.inertElems.forEach((elm) => {
          elm.removeAttribute("inert");
        });
      }

      document
        .querySelector(`[aria-controls="${this.id}"]`)
        ?.setAttribute("aria-expanded", "false");

      setTimeout(() => {
        this.style.display = "none";
      }, 501);
    }
  }

  if (typeof customElements.get("sidebar-drawer") == "undefined") {
    customElements.define("sidebar-drawer", SidebarDrawer);
  }
}

if (typeof MobileNavigation !== "function") {
  class MobileNavigation extends HTMLElement {
    constructor() {
      super();
      this._openedFirstSubmenu = false;
      this._openedSecondSubmenu = false;

      this.querySelectorAll(".has-submenu > a").forEach((elm) => {
        elm.addEventListener("click", (e) => {
          e.preventDefault();
          if (!this._openedFirstSubmenu) {
            this._openedFirstSubmenu = true;
            this.classList.add("opened-first-submenu");
            this.closest("sidebar-drawer").scrollTo({ top: 0 });
          }
          e.target.closest("li").classList.add("opened");
          this._resizeContainer();
        });
      });

      this.querySelectorAll(".has-babymenu > a").forEach((elm) => {
        elm.addEventListener("click", (e) => {
          e.preventDefault();
          if (!this._openedSecondSubmenu) {
            this._openedSecondSubmenu = true;
            this.classList.add("opened-second-submenu");
            this.closest("sidebar-drawer").scrollTo({ top: 0 });
          }
          e.target.closest("li").classList.add("opened");
          this._resizeContainer();
        });
      });

      this.querySelectorAll(".submenu-back a").forEach((elm) => {
        elm.addEventListener("click", (e) => {
          if (this._openedSecondSubmenu) {
            this._openedSecondSubmenu = false;
            this.classList.remove("opened-second-submenu");
            this._resizeContainer();
          } else if (this._openedFirstSubmenu) {
            this._openedFirstSubmenu = false;
            this.classList.remove("opened-first-submenu");
            this._resizeContainer(true);
          }
          this.closest("sidebar-drawer").scrollTo({ top: 0 });
          setTimeout(() => {
            e.target.closest("li.opened").classList.remove("opened");
          }, 301);
          e.preventDefault();
        });
      });
    }

    _resizeContainer(main = false) {
      if (main) {
        this.style.height = `auto`;
      } else {
        if (this._openedSecondSubmenu) {
          this.style.height = `${this.querySelector(".has-babymenu.opened .babymenu")
            ?.scrollHeight || 0
            }px`;
        } else if (this._openedFirstSubmenu) {
          this.style.height = `${this.querySelector(".has-submenu.opened .submenu")?.scrollHeight ||
            0
            }px`;
        }
      }
    }
  }

  if (typeof customElements.get("mobile-navigation") == "undefined") {
    customElements.define("mobile-navigation", MobileNavigation);
  }
}
// Fine
